export const SKINS = {
    standard: 'standard',
    inverted: 'inverted',
    light: 'light',
    transparent: 'transparent',
    premium: 'premium',
    dark: 'dark',
};
export const SIZES = {
    tiny: 'tiny',
    small: 'small',
    medium: 'medium',
    large: 'large',
};
export const PRIORITY = {
    primary: 'primary',
    secondary: 'secondary',
    tertiary: 'tertiary',
};
export const iconChildSize = {
    [SIZES.tiny]: '18px',
    [SIZES.small]: '18px',
    [SIZES.medium]: '24px',
    [SIZES.large]: '24px',
};
export const testDataHooks = {
    iconOfIconButton: 'iconbutton-icon',
};
//# sourceMappingURL=constants.js.map